/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	PipelineStageMovePathParams,
	PipelineStageMoveRequest,
	PipelineStageMoveResponse,
} from '../types/PipelineStageMove'

/**
 * POST /campaigns/:campaign/pipeline-stages/candidates
 * @see backend/nexus/modules/Campaign/Http/Controllers/PipelineStageController.php PipelineStageController::move
 */
export async function pipelineStageMove(
	campaign: PipelineStageMovePathParams['campaign'],
	data: PipelineStageMoveRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<PipelineStageMoveResponse>> {
	return axiosInstance.post(`/campaigns/${campaign}/pipeline-stages/candidates`, data, config)
}
